// extracted by mini-css-extract-plugin
export default {"root":"TextEditor_root__oGZ0D","editor":"TextEditor_editor__He3tt"};